import { useTranslation } from 'react-i18next'

export function MarketAnalysisHeader() {
  const { t } = useTranslation()

  return (
    <div className="bg-primary-50 dark:bg-primary-900/20 rounded-xl border border-primary-200 dark:border-primary-800 p-5">
      <h3 className="text-lg font-bold text-primary-800 dark:text-primary-300">{t('amazonListing.report.marketAnalysis')}</h3>
      <p className="text-sm text-primary-600 dark:text-primary-400 mt-1">{t('amazonListing.report.marketAnalysisDesc')}</p>
    </div>
  )
}
